import { type FC } from 'react';
import { cx } from '../../../utils/cx';
import type { AlertProps } from './alerts.types';
import { alertColorVariants, defaultIcons } from './alerts.constants';
import {
  AlertIcon,
  AlertCloseButton,
  AlertActions
} from './alert-sub-components';

export const FullWidthAlert: FC<AlertProps> = ({
  color = 'gray',
  title,
  description,
  showCloseButton = false,
  onClose,
  dismissText,
  onDismiss,
  actionText,
  onAction,
  className,
  children
}) => {
  const colors = alertColorVariants[color];
  const Icon = defaultIcons[color];

  return (
    <div
      className={cx(
        'flex w-full flex-col items-center border-b md:py-(--gn-spacing-md)',
        colors.fullWidth,
        className
      )}
    >
      <div className="w-full max-w-container items-start md:items-center gap-(--gn-spacing-xl) px-(--gn-container-padding-mobile) py-(--gn-spacing-xl) md:py-(--gn-spacing-lg) flex flex-col md:flex-row md:px-(--gn-container-padding-desktop)">
        <AlertIcon
          icon={Icon}
          className="hidden md:block"
          iconClass={colors.icon}
          ringClass={colors.iconRing}
        />
        <div className="flex flex-1 flex-wrap items-start gap-(--gn-spacing-xs)">
          {title && (
            <p className={cx('text-sm font-semibold', colors.title)}>{title}</p>
          )}
          {description && (
            <p className={cx('text-sm font-normal', colors.description)}>
              {description}
            </p>
          )}
          {children}
        </div>
        <div className="flex items-center gap-(--gn-spacing-lg)">
          <AlertActions
            dismissText={dismissText}
            onDismiss={onDismiss}
            actionText={actionText}
            onAction={onAction}
            dismissClass={colors.dismissButton}
            actionClass={colors.actionButton}
            className="pr-(--gn-spacing-lg)"
          />
          {showCloseButton && (
            <AlertCloseButton
              onClick={onClose}
              className={colors.closeButton}
            />
          )}
        </div>
      </div>
    </div>
  );
};
